import styled from 'styled-components';
import SuccessPageAttribution from 'views/PostEnrollment/SuccessPageAttribution';
import SuccessPageButton from 'views/PostEnrollment/SuccessPageButtons';
import cbRewardsCard from 'views/SuccessCBRewards/cbRewardsCard.svg';
import {
  CenteredStickySubmitButtonWrapper,
  Content,
  SpacedChecklistDisclaimerText,
  Title,
} from 'views/SuccessCBRewards/Layout';
import {
  RewardsOrderedList,
  RewardsOrderedListText,
} from 'views/SuccessCBRewards/RewardsOrderedList';

import { GhostLink } from 'chime-ui/components/Button';

import {
  Card,
  CardContainer,
  PageWrapper,
  PostEnrollmentChimeLogo as ChimeLogo,
} from 'styles/styleMixins';

import { atmFeesArticleLink } from 'utils/linkHelper';

const seeDetailsLinkText = 'See here for details.';
const seeDetailsLink = atmFeesArticleLink;
const SuccessPage = () => {
  return (
    <SuccessPageAttribution>
      <PageWrapper>
        <CustomCard showFooterDisclosure>
          <CardContainer>
            <Content>
              <ChimeLogo alwaysShow />
              <CBRewardsCard />
              <Title>Say hello to Cash Rewards*</Title>
              <RewardsOrderedList>
                <RewardsOrderedListText>
                  Get unlimited 1.5% cash back on quarterly categories
                </RewardsOrderedListText>
                <RewardsOrderedListText>
                  Build credit with everyday purchases and on-time payments
                </RewardsOrderedListText>
                <RewardsOrderedListText>
                  No interest or annual fees<sup>1</sup>
                </RewardsOrderedListText>
              </RewardsOrderedList>
              <CenteredStickySubmitButtonWrapper>
                <SuccessPageButton
                  justifyContent="center"
                  variation="l"
                  eventContext="success_cb_rewards"
                >
                  Get the app
                </SuccessPageButton>
              </CenteredStickySubmitButtonWrapper>
            </Content>
          </CardContainer>
        </CustomCard>
        <SpacedChecklistDisclaimerText>
          * Approval is contingent on you receiving a single $200+ qualifying
          direct deposit into your Chime Checking Account within 30 days of
          submitting your application. <br />
          <br />
          <sup>1</sup> Out-of-network ATM withdrawal fees may apply.{' '}
          <GhostLink href={seeDetailsLink} target="_blank">
            {seeDetailsLinkText}
          </GhostLink>
        </SpacedChecklistDisclaimerText>
      </PageWrapper>
    </SuccessPageAttribution>
  );
};

export default SuccessPage;

const CBRewardsCard = styled.img.attrs({
  src: cbRewardsCard,
  alt: 'Credit Build Rewards Card',
})`
  width: 100%;
`;

const CustomCard = styled(Card)`
  margin-bottom: 32px;
`;